define('bizzabo/models/Questions',['bizzabo/models/Question', 'bizzabo/models/SyncedCollection'], function(Question, SyncedCollection) {

    var Questions = SyncedCollection.extend({
        model : Question,

        initialize : function() {
            this.listenTo(this, 'add reset remove', this.updateModelsIndex);
            this.listenTo(this, 'sync', this.setAnswersIndices);
        },

        updateModelsIndex : function() {
            var thisModel = this;
            _.each(this.models, function(question) {
                question.set('localPosition', thisModel.indexOf(question) + 1);
            })
        }
    });

    return Questions;

});
